import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-798d621c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "eventDialog" }
const _hoisted_2 = {
  key: 0,
  class: "my-3 mt-3"
}
const _hoisted_3 = ["id"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "row"
}
const _hoisted_6 = { class: "col-sm-10" }
const _hoisted_7 = { class: "col-sm-10" }
const _hoisted_8 = {
  key: 1,
  class: "col-sm-10",
  role: "button"
}
const _hoisted_9 = {
  key: 0,
  class: "eventContent"
}
const _hoisted_10 = {
  key: 1,
  class: "attendanceWrapper pt-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Attendance = _resolveComponent("Attendance")!
  const _component_wdw_dynbox = _resolveComponent("wdw-dynbox")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_wdw_dynbox, {
      title: _ctx.event.title,
      config: { showControls: false }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          (_ctx.eventAttributes && _ctx.eventAttributes.length !== 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eventAttributes, (eventAttribute, index) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: eventAttribute.value
                  }, [
                    _withDirectives(_createElementVNode("span", {
                      id: eventAttribute.attr
                    }, null, 8, _hoisted_3), [
                      [_directive_dompurify_html, eventAttribute.value]
                    ]),
                    (_ctx.eventAttributes.length - 2 === index)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_4, ","))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.event.startDate)
            ? (_openBlock(), _createElementBlock("dl", _hoisted_5, [
                _withDirectives(_createElementVNode("dt", { class: "col-sm-2" }, _toDisplayString(_ctx.domainStore.translate('calendar.event.startDate')) + ":", 513), [
                  [_vShow, _ctx.event.startDate]
                ]),
                _withDirectives(_createElementVNode("dd", _hoisted_6, null, 512), [
                  [_directive_dompurify_html, _ctx.event.startDate]
                ]),
                _withDirectives(_createElementVNode("dt", { class: "col-sm-2" }, _toDisplayString(_ctx.domainStore.translate('calendar.event.endDate')) + ":", 513), [
                  [_vShow, _ctx.event.endDate]
                ]),
                _withDirectives(_createElementVNode("dd", _hoisted_7, null, 512), [
                  [_directive_dompurify_html, _ctx.event.endDate]
                ]),
                _withDirectives(_createElementVNode("dt", { class: "col-sm-2" }, _toDisplayString(_ctx.domainStore.translate('calendar.event.place')) + ":", 513), [
                  [_vShow, _ctx.event.place]
                ]),
                (_ctx.mapLink)
                  ? _withDirectives((_openBlock(), _createElementBlock("dd", {
                      key: 0,
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.mapLink && _ctx.mapLink(...args))),
                      class: "col-sm-10",
                      role: "button"
                    }, null, 512)), [
                      [_directive_dompurify_html, _ctx.event.place ? _ctx.event.place : _ctx.domainStore.translate('calendar.event.no-place-info')]
                    ])
                  : _withDirectives((_openBlock(), _createElementBlock("dd", _hoisted_8, null, 512)), [
                      [_directive_dompurify_html, _ctx.event.place ? _ctx.event.place : _ctx.domainStore.translate('calendar.event.no-place-info')]
                    ])
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.event.content)
          ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_9, null, 512)), [
              [_directive_dompurify_html, _ctx.event.content],
              [_vShow, _ctx.event.content]
            ])
          : _createCommentVNode("", true),
        (_ctx.event.track_attendance && _ctx.calendarState.calendarConfig && _ctx.calendarState.calendarConfig.allow_attendance)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(_component_Attendance, {
                assignedAttributes: _ctx.eventAssignedAttributes,
                privacyPageUrl: _ctx.privacyPageUrl
              }, null, 8, ["assignedAttributes", "privacyPageUrl"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["title"])
  ]))
}